<template>
  <v-container class="fill-height">
    <v-snackbar v-model="error" :top="true" :right="true" :vertical="true" color="error" :timeout="5000">
      Something went wrong. Please check the developer console!
      <v-btn dark text @click="error = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="success" :top="true" :right="true" :vertical="true" color="success" :timeout="5000">
      Language successfully created
      <v-btn dark text @click="success = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-row justify="center">
      <v-dialog v-model="confirmDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>Do you really want to delete these records? This process cannot be undone.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="cancel">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="agree">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card class="v-table-card" :elevation="3">
      <v-data-table
        :headers="headers"
        :items="languages"
        :loading="tableLoading"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <div class="flex-grow-1"></div>
            <v-btn color="indigo" dark class="mb-1" @click="createDialog = true">
              Добави нов език
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="props">
          <v-icon small class="mr-2">mdi-pencil</v-icon>
          <!-- <v-icon @click.native="handleDeleteClick(props.item.id)" small>mdi-delete</v-icon> -->
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="createDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Добави език</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="isValid">
              <v-row>
                <v-col md="12">
                  <v-text-field name="title" prepend-icon="mdi-pencil" label="Код" v-model="code" :rules="[rules.required]" required></v-text-field>
                </v-col>
                <v-col md="12">
                  <v-text-field name="title" prepend-icon="mdi-pencil" label="Име" v-model="name" :rules="[rules.required]" required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="createDialog = false">Затвори</v-btn>
          <v-btn color="blue darken-1" text @click="handleLanguageAddButtonClick">Добави</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createLanguage } from '@/repositories/language.repository'
export default {
  data () {
    return {
      isValid: false,
      createDialog: false,
      tableLoading: true,
      code: null,
      name: null,
      success: false,
      error: false,
      headers: [
        { text: 'Код', value: 'code', width: '10%' },
        { text: 'Име', value: 'name', width: '20%' },
        { text: 'Дата на създаване', value: 'createdAt' },
        { text: 'Последно редактиране', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
      ],
      rules: {
        required: value => !!value || 'Това поле е задължително!'
      }
    }
  },
  created () {
    this.$store.dispatch('fetchLanguages')
      .then(() => this.tableLoading = false)
  },
  computed: {
    languages () {
      return this.$store.state.language.languages
    }
  },
  methods: {
    handleLanguageAddButtonClick () {
      this.$refs.form.validate()
      if (!this.isValid) {
        return
      }

      try {
        createLanguage({ code: this.code, name: this.name })
          .then(response => {
            if (response.data) {
              const { success } = response.data
              this.success = success
              this.error = !this.success

              this.createDialog = !this.success
              this.tableLoading = this.success

              this.$store.dispatch('fetchLanguages')
                .then(() => this.tableLoading = false)

              this.reset()
              return;
            }

            console.log(response.message);
            this.error = true;
            this.success = false;
          })
      } catch (error) {
        console.log(error)
        this.error = true
        this.success = false
      }
    },
    reset () {
      this.$refs.form.reset()
    }
  }
}
</script>
